import { useScreenMessage } from '@gogame/screens';

import { checkTerminateIoStatus } from 'scenes/IO/sources/io';

export const useCheckTerminateIoStatus = (process) => {
  const { showErrorMessage } = useScreenMessage();

  return async ({ id, date }) => {
    return process(checkTerminateIoStatus({ id, date })).catch((e) => {
      showErrorMessage(e.message);
      return Promise.reject(e);
    });
  };
};
